import { render, staticRenderFns } from "./koList.vue?vue&type=template&id=c793623c&scoped=true&name=koList&"
import script from "./koList.vue?vue&type=script&lang=js&"
export * from "./koList.vue?vue&type=script&lang=js&"
import style0 from "./koList.vue?vue&type=style&index=0&id=c793623c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c793623c",
  null
  
)

export default component.exports